import { shallowMount } from "@vue/test-utils";
import Paso1 from "@/views/Paso1";

describe("Paso1 component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Paso1, {
      propsData: {
        embeded: false
      }
    });
  });

  it("Renders del component Paso1", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
